// src/api/authApi.js
import { post } from './api';  // Import the base POST function

// Register API
const register = async (mobile_number, password) => {
  const data = { mobile_number, password };
  return post('/auth/register', data);  // POST request to the /auth/register endpoint
};

// Login API
const login = async (mobile_number, password) => {
  const data = { mobile_number, password };
  return post('/auth/login', data);  // POST request to the /auth/login endpoint
};

export { register, login };
